export default {
  space: {
    0: 0,
    4: 4,
    8: 8,
    12: 12,
    16: 16,
    20: 20,
    24: 24,
    40: 40,
    32: 32,
    64: 64,
    128: 128,
    256: 256,
    512: 512,
  },
  fontSizes: {
    12: 12,
    14: 14,
    16: 16,
    18: 18,
    20: 20,
    24: 24,
    small: 12,
    default: 14,
    large: 16,
  },
  fontWeights: {
    semibold: 600,
  },
  breakpoints: ['1280px', '32em', '48em'],
  colors: {
    background: '#F0F2F5',
    legacyPrimary: '#063340',
    primary: '#049bdd',
    gray: '#777572',
    lightgray: '#D0D0D0',
    danger: '#DD0426',
    info: '#049BDD',
    success: '#00AC70',
    alert: '#F28100',
  },
};
